import React, { useEffect, useMemo } from 'react';
import { useStyles } from './MailboxFolders.styles';
import { Divider, Typography } from '@material-ui/core';
import { folders } from './helpers';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { mailboxActions } from '../../reducers/mailboxReducer/mailboxSlice';
import { Folder, FoldersSubFolder } from '../../models/communication.types';
import TooltipOne from '../TooltipOne/TooltipOne.component';

export const MailboxFolders: React.FC<{ forcedFolder?: Folder; isMenuMinimized?: boolean }> = (props) => {
  const classes = useStyles();

  const activeFolder = useSelector((state: RootState) => state.mailbox.activeFolder);
  const helpDeskReportedFolderUnreadMessages = useSelector(
    (state: RootState) => state.mailbox.helpDeskReportedFolderUnreadMessages,
  );
  const messagesReceivedFolderUnreadMessages = useSelector(
    (state: RootState) => state.mailbox.messagesReceivedFolderUnreadMessages,
  );
  const specialCasesToSolveFolderUnreadMessages = useSelector(
    (state: RootState) => state.mailbox.specialCasesToSolveFolderUnreadMessages,
  );
  const isLoadingMessageContent = useSelector((state: RootState) => state.mailbox.isLoadingMessageContent);
  
  const unreadMessages: Folder[] = useMemo(() => {
    const result: Folder[] = [];

    if (helpDeskReportedFolderUnreadMessages > 0) {
      result.push(Folder.HelpdeskReported);
    }
    if (messagesReceivedFolderUnreadMessages > 0) {
      result.push(Folder.Received);
    }
    if (specialCasesToSolveFolderUnreadMessages > 0) {
      result.push(Folder.SpecialCasesToSolve);
    }
    return result;
  }, [
    helpDeskReportedFolderUnreadMessages,
    messagesReceivedFolderUnreadMessages,
    specialCasesToSolveFolderUnreadMessages,
  ]);

  const dispatch = useDispatch();

  const handleSelectFolder = (subfolder: FoldersSubFolder) => {
    if (isLoadingMessageContent) return;
    dispatch(mailboxActions.changeFolder(subfolder.id));
  };

  useEffect(() => {
    if (isLoadingMessageContent) return;
    props.forcedFolder && dispatch(mailboxActions.changeFolder(props.forcedFolder));
  }, [props.forcedFolder]);

  return (
    <div className={classes.foldersContainer}>
      {folders.map((folder, index) => (
        <React.Fragment key={folder.name}>
          {props?.isMenuMinimized ? (
            index === 0 ? null : (
              <Divider />
            )
          ) : (
            <Typography className={classes.header}>{folder.name}</Typography>
          )}
          <ul className={classes.folders}>
            {folder.items.map((subfolder) => {
              return (
                <TooltipOne
                  key={`tooltip${subfolder.text}`}
                  title={props?.isMenuMinimized ? `${folder.name} - ${subfolder.text}` : ''}
                  placement="right"
                >
                  <li
                    className={[
                      classes.listItem,
                      activeFolder === subfolder.id ? classes.activeListItem : classes.listItem,
                    ].join(' ')}
                    key={subfolder.text}
                    tabIndex={0}
                    onClick={() => handleSelectFolder(subfolder)}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        handleSelectFolder(subfolder);
                      }
                    }}
                  >
                    <>
                      <div
                        className={[
                          classes.icon,
                          activeFolder === subfolder.id ? classes.activeIcon : classes.icon,
                        ].join(' ')}
                      >
                        {subfolder.icon}
                      </div>
                      {!props?.isMenuMinimized && (
                        <span
                          className={[
                            classes.listItemText,
                            unreadMessages.some((id) => id === subfolder.id)
                              ? classes.unreadMessage
                              : classes.listItemText,
                            activeFolder === subfolder.id ? classes.activelistItemText : classes.listItemText,
                          ].join(' ')}
                        >
                          {subfolder.text}
                        </span>
                      )}
                    </>
                  </li>
                </TooltipOne>
              );
            })}
          </ul>
        </React.Fragment>
      ))}
    </div>
  );
};
